import styled from "styled-components";

export const SkeletonRoot = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const SkeletonRow = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 22px 24px;
  border: 1px solid ${props => props.theme.palette.colors.borderSoft};
  border-radius: 18px;
  background: ${props => props.theme.palette.colors.surfaceElevated};
`;
